/**
 * 3位/千分位加逗号
 * @param {number} 原数
 * @returns {number} rem大小
 */

function reverseStr(str: string) {
  return str.split('').reverse().join('')
}
function replace3Int(str: string) {
  return str.replace(/(\d{3})(?=\d)/g, '$1,')
}

export const currency = (intStr: string | number) => {
  return reverseStr(replace3Int(reverseStr(String(intStr))))
}
